// 천단위 마다 콤마 추가(ex: 1000 => 1,000)
export const formatNumber = (num: number): string => {
  if (num === null) {
    return "";
  }
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
